var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.scrollTop > 1500),expression:"scrollTop > 1500"}],staticClass:"the-scroll-button",attrs:{"fixed":"","fab":"","bottom":"","right":"","small":_vm.$vuetify.breakpoint.mdAndDown,"color":"accent"},on:{"click":_vm.scrollUp}},[_c('v-icon',[_vm._v("mdi-arrow-up")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }